Object.defineProperty(exports, "__esModule", {value: true});
var Dictionary = function (weakKeys) {}
Dictionary.prototype.constructor = Dictionary;

module.exports.default = Dictionary;